module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/monogram-18b50a38b921e0037a5383d2924ccbc8.jpg";